import { Card, Heading, Input, Stack } from "@softmax/design-system";
import {
  breakpoints,
  fonts,
  fontSizes,
  spacing,
} from "@softmax/design-system/tokens.stylex";
import * as stylex from "@stylexjs/stylex";
import type { ReactNode } from "react";
import type { AccountProfileDraft } from "./profile-state";

export function AccountProfile({
  id,
  profile,
  avatar,
  onProfileChange,
}: {
  readonly id: string;
  readonly profile: AccountProfileDraft;
  readonly avatar: ReactNode;
  readonly onProfileChange: (changes: Partial<AccountProfileDraft>) => void;
}) {
  return (
    <Card>
      <Stack width="auto">
        <Heading level={2}>About you</Heading>
        {avatar}
        <div {...stylex.props(styles.fields)}>
          <label htmlFor={`${id}-name`} {...stylex.props(styles.field)}>
            Name
            <Input
              id={`${id}-name`}
              value={profile.name}
              onChange={(event) =>
                onProfileChange({ name: event.target.value })
              }
              autoComplete="name"
              required
              maxLength={200}
            />
          </label>
          <label htmlFor={`${id}-email`} {...stylex.props(styles.field)}>
            Email
            <Input
              id={`${id}-email`}
              value={profile.email}
              onChange={(event) =>
                onProfileChange({ email: event.target.value })
              }
              autoComplete="email"
              type="email"
              required
              maxLength={320}
            />
          </label>
          <label
            htmlFor={`${id}-institution`}
            {...stylex.props(styles.field, styles.full)}
          >
            Institution
            <Input
              id={`${id}-institution`}
              value={profile.institution}
              onChange={(event) =>
                onProfileChange({ institution: event.target.value })
              }
              autoComplete="organization"
              required
              maxLength={200}
            />
          </label>
        </div>
      </Stack>
    </Card>
  );
}
const styles = stylex.create({
  fields: {
    display: "grid",
    gridTemplateColumns: { default: "1fr 1fr", [breakpoints.compact]: "1fr" },
    gap: spacing.space16,
  },
  field: {
    display: "grid",
    gap: spacing.space8,
    minWidth: 0,
    fontFamily: fonts.sans,
    fontSize: fontSizes.label,
  },
  full: { gridColumn: "1 / -1" },
});
